// Styles
import styled from 'styled-components'

// Core
import React from 'react'

// Components, actions, models, etc.
import FormField from './FormField'
import Address from 'components/Address'
import Image from 'components/Image'
import MetaDataList from 'components/MetaDataList'
import {getAddressImageUrl, getAddressMetaData} from 'services/addressServices'
import type {PropertyType} from 'types/propertyTypes'

const PropertyDetailsFormField = ({property}: {property: PropertyType}) => {
  const {address, metaData} = getAddressMetaData(property)

  return (
    <FormField label='Property Details'>
      <AddressWrapperStyle>
        <Image
          width='48px'
          height='48px'
          asImg
          className='address-image'
          src={getAddressImageUrl(address)}
        />
        <div>
          <Address address={address} sqaPrefix='header' />
          <MetaDataList metaData={metaData} />
        </div>
      </AddressWrapperStyle>
    </FormField>
  )
}

const AddressWrapperStyle = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;

  .address-image {
    border-radius: 6px;
  }

  .meta-data {
    font-size: 0.875rem;
  }
`
export default PropertyDetailsFormField
